import ownerDocument from './owner-document';
export var getDocumentElement = function (element) { return ownerDocument(element).documentElement; };



//////////////////
// WEBPACK FOOTER
// ./~/@progress/kendo-popup-common/dist/es/document.js
// module id = 214
// module chunks = 93